import { render, staticRenderFns } from "./FormUserProject.vue?vue&type=template&id=35c8a110&"
import script from "./FormUserProject.vue?vue&type=script&lang=js&"
export * from "./FormUserProject.vue?vue&type=script&lang=js&"
import style0 from "./FormUserProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports